import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { newTherapyTemplateAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  EDIT_THERAPY_TEMPLATE_REQUEST,
  EDIT_THERAPY_TEMPLATE_SUCCESS,
  EDIT_THERAPY_TEMPLATE_LOADING,
  EDIT_THERAPY_TEMPLATE_FAILURE,
} = newTherapyTemplateAction;

function* editTherapyTemplate(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: EDIT_THERAPY_TEMPLATE_LOADING });

    const reponse = yield call(therapyPlanningService.editTherapyTemplates, payload.payload);
    if (reponse?.status === 200) {
      yield put({
        type: EDIT_THERAPY_TEMPLATE_SUCCESS,
        payload: reponse?.data,
      });
    } else throw reponse.data;
  } catch (error) {
    yield put({ type: EDIT_THERAPY_TEMPLATE_FAILURE, payload: error });
  }
}

function* editTherapyTemplateSaga() {
  yield takeEvery(EDIT_THERAPY_TEMPLATE_REQUEST, editTherapyTemplate);
}

export default editTherapyTemplateSaga;
